import { defineComponent as _defineComponent } from 'vue'
import ShokurekishoCareerJobProjectEditPanel from '@/components/format-edit/shokurekisho/ShokurekishoCareerJobProjectEditPanel.vue'
import { useShokurekishoHistoryItem } from '@/composables/format-edit/useShokurekishoHistoryItem'
import type { ShokurekishoJobHistoryItem } from '@/composables/format-edit/useShokurekishoFormatData'
import hopeJobcategoryOptions from '@/utils/format-edit/hopeJobcategoryOptions.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'HistoryItemJob_career',
  props: {
    item: null,
    index: null,
    length: null,
    descriptionPlaceholder: null,
    descriptionMaxLength: null,
    minYear: null,
    maxYear: null,
    activeHistoryItem: null
  },
  emits: ["add-history-item", "delete-history-item", "move-history-item", "add-project-history-item", "delete-history-item-detail", "move-history-item-detail"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: 'add-history-item',
    index: number,
    item?: ShokurekishoJobHistoryItem
  ): void
  (e: 'delete-history-item', index: number): void
  (e: 'move-history-item', params: { index: number; to: string }): void
  (
    e: 'add-project-history-item',
    index: number,
    item?: ShokurekishoJobHistoryItem
  ): void
  (e: 'delete-history-item-detail', index: number, index2: number): void
  (
    e: 'move-history-item-detail',
    params: { index: number; to: string },
    parentIndex: number
  ): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: ShokurekishoJobHistoryItem
  index: number
  length: number
  descriptionPlaceholder?: string
  descriptionMaxLength?: number
  minYear?: number | string
  maxYear?: number | string
  activeHistoryItem?: string
};





const {
  historyItemForm,
  errors,
  editableItem,
  isActive,
  computedMinYear,
  computedMaxYear,
  rules,
  handleCommand,
  deleteDetail,
  moveUpDetail,
  moveDownDetail,
  deactivateHistoryItem
} = useShokurekishoHistoryItem(props, emit)

return { __sfc: true,props, emit, historyItemForm, errors, editableItem, isActive, computedMinYear, computedMaxYear, rules, handleCommand, deleteDetail, moveUpDetail, moveDownDetail, deactivateHistoryItem, ShokurekishoCareerJobProjectEditPanel, hopeJobcategoryOptions }
}

})